import React, { Fragment } from "react"
import {
    Grid,
    Tooltip,
    Typography,
    makeStyles, 
    Button
} from "@material-ui/core"
import { useState } from "react"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { showModal } from "../../../redux/actions"
import InstructionModal from "./components/InstructionModal"
import InfoIcon from '@material-ui/icons/Info'
import { useIntl } from "react-intl"

const useTooltipStyles = makeStyles(theme => ({
	tooltip: {
        backgroundColor: '#e6f2ff',
        color: 'black', 
        boxShadow: '0 1px 1px #ccc', 
        maxWidth: '768px',
        width: 'auto'
	}
  }))

const BilateralQuestionInfo = ({
    ...rest
}) => {
    const [title, setTitle] = useState(null)
    const [titleRequired, setTitleRequired] = useState(null)
    const [instructions, setInstruction] = useState(null)
    const [isOptional, setIsOptional] = useState(true)
    const [displayInstructionAsIcon, setDisplayInstructionAsIcon] = useState(false)

    const tooltipStyles = useTooltipStyles()
    const dispatch = useDispatch()
    const intl = useIntl()

    const instructionClickHandler = () => {
		dispatch(showModal(InstructionModal,
			{
				title: title,
				text: instructions
			}
		))
	}

    useEffect(
		() => {
			let optional = true

			Object.keys(rest).map((key, index) => {
				const question = rest[key]

                if (index === 0) {
                    setTitle(question.title)
                    setInstruction(question.instructions)
                    setDisplayInstructionAsIcon(question.displayInstructionAsIcon)
                    setTitleRequired(question.titleRequered)
                }

				if (!question.isOptional) {
					optional = question.isOptional
				}
			})

			setIsOptional(optional)
		},
		[rest]
	)


    return (
        <Grid
            container
            direction="column"
            className="bilateral-title"
        >
            <Grid item>
                <Fragment>
                    <Grid container direction='row' spacing={1}>
                        <Grid item>
                            <Typography
                                data-testid="writable-question-title"
                                variant='h4'
                            >
                                {`${title}${isOptional ? '' : ' *'}`}
                            </Typography>
                        </Grid>
                        {displayInstructionAsIcon
                        && instructions
                        && instructions.trim()
                        &&
                        <Grid item style={{ display: 'flex', alignItems: 'center'}}>
                            <Tooltip 
                                enterTouchDelay={0}
                                disableTouchListener={true}
                                title={
                                    <Typography color="inherit" style={{ fontSize: '12px' }}>
                                        <span dangerouslySetInnerHTML={{ __html: instructions }} />
                                    </Typography>
                                }
                                classes={{
                                    tooltip: tooltipStyles.tooltip
                                }}
                            >
                                <InfoIcon style={{ fontSize: '20px', color: '#007aff', marginRight: '5px' }}  />
                            </Tooltip>
                            <Grid item>
                                <Button
                                data-testid="writable-question-instructions"
                                style={{ display: 'flex', textAlign: 'left', width: 'auto' }}
                                onClick={instructionClickHandler} >
                                    <Typography
                                        data-testid="writable-question-instructions-helper"
                                        variant='body2'
                                        style={{ opacity: '0.8', color: '#000', textDecoration: 'underline', fontSize: '14px' }}>
                                        {intl.formatMessage({ id: 'app.survey.questions.instructionIconHelperText' })}
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>}
                    </Grid>
                    <span style={{ color: 'red' }}>{titleRequired}</span>
                </Fragment>
            </Grid>
            {
                !!instructions
                && !displayInstructionAsIcon
                && <Grid item>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography
                                data-testid="writable-question-instructions"
                                variant='subtitle2'
                            >
                                <span dangerouslySetInnerHTML={{ __html: instructions }} />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Grid>
    )
}

export default BilateralQuestionInfo
